"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

// https://chaewonkong.github.io/posts/react-forceUpdate.html
var useForceUpdate = function useForceUpdate() {
  var _useReducer = (0, _react.useReducer)(function (x) {
    return x + 1;
  }, 0),
      _useReducer2 = (0, _slicedToArray2["default"])(_useReducer, 2),
      forceUpdate = _useReducer2[1];

  return forceUpdate;
};

var _default = useForceUpdate;
exports["default"] = _default;
//# sourceMappingURL=useForceUpdate.js.map